<template>
    <div
        ref="conditionalText"
        :class="this.class"
    >
        <span
            class="conditional-default"
            :data-conditional-key="path"
            v-html="replaceVariables(text.text)"
        ></span>

        <template
            v-for="(conditional, index) of text.conditionalTexts"
            :key="index"
        >
            <span
                v-if="isMatch(conditional.value.conditionals)"
                class="conditional"
                :class="stringIsEmpty(conditional.value.text) ? 'conditional--hide' : ''"
                v-html="replaceVariables(conditional.value.text)"
            ></span>
        </template>
    </div>
</template>

<script>
import Page from '../../../../../../resources/frontend/js/mixins/page.vue';
import ReplaceVariables from '../../../../../../resources/frontend/js/mixins/replace-variables.vue';
import searchForAnchors from '@mixins/utils/search-for-anchors';
import { isMatch } from '@mixins/utils/conditions';

export default {
    mixins: [
        Page,
        ReplaceVariables,
    ],

    props: {
        path: {
            type: String,
            required: true,
        },

        class: {
            type: String,
            required: true,
        },

        text: {
            type: Object,
            required: true,
        },
    },

    methods: {
        isMatch,
    },

    mounted() {
        if (!this.$refs.conditionalText) return;

        for (const dialog of this.$refs.conditionalText.querySelectorAll('[data-dialog]')) {
            dialog.addEventListener('click', () => {
                this.$store.commit('dialog/show', dialog.getAttribute('data-dialog'));
            });
        }

        searchForAnchors(this.$refs.conditionalText.querySelectorAll('.anchor'));
    },
};
</script>

<style lang="scss" scoped>
.conditional-default:has(+ .conditional) {
    display: none;
}

.conditional--hide {
    display: none;
}
</style>
